(function () {
  if (window.__grCartUpsellDragScroll) return;
  window.__grCartUpsellDragScroll = true;

  function findUpsellLists(root = document) {
    const lists = [...root.querySelectorAll('.gr-cart-upsell__list')];

    root.querySelectorAll('*').forEach((element) => {
      if (element.shadowRoot) {
        lists.push(...findUpsellLists(element.shadowRoot));
      }
    });

    return lists;
  }

  function initDragScroll() {
    const lists = findUpsellLists();

    lists.forEach((list) => {
      if (list.dataset.dragReady === 'true') return;

      list.dataset.dragReady = 'true';

      let isDragging = false;
      let startX = 0;
      let startScrollLeft = 0;

      list.addEventListener('pointerdown', (event) => {
        if (event.button !== 0) return;
        if (list.scrollWidth <= list.clientWidth) return;

        isDragging = true;
        startX = event.clientX;
        startScrollLeft = list.scrollLeft;

        list.classList.add('is-dragging');
      });

      list.addEventListener('pointermove', (event) => {
        if (!isDragging) return;

        event.preventDefault();

        const distance = event.clientX - startX;
        list.scrollLeft = startScrollLeft - distance;
      });

      list.addEventListener('pointerup', () => {
        isDragging = false;
        list.classList.remove('is-dragging');
      });

      list.addEventListener('pointercancel', () => {
        isDragging = false;
        list.classList.remove('is-dragging');
      });

      list.addEventListener('mouseleave', () => {
        isDragging = false;
        list.classList.remove('is-dragging');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initDragScroll);

  setInterval(initDragScroll, 1000);
})();